import { useRef } from "react";
import { ChevronLeft, ChevronRight, ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

const PRODUCTS = [
  { name: "Leather Tote Bag", category: "Bags", image: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=800&q=80" },
  { name: "Classic Sneakers", category: "Footwear", image: "https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?w=800&q=80" },
  { name: "Chronograph Watch", category: "Watches", image: "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=800&q=80" },
  { name: "Gold Pendant Set", category: "Jewellery", image: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=800&q=80" },
  { name: "Boutique Apparel", category: "Apparel", image: "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?w=800&q=80" },
  { name: "Running Shoes Pro", category: "Footwear", image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800&q=80" },
  { name: "Statement Earrings", category: "Jewellery", image: "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=800&q=80" },
  { name: "Gourmet Spice Pack", category: "Food", image: "https://images.unsplash.com/photo-1556905055-8f358a7a47b2?w=800&q=80" },
];

export default function FeaturedProducts() {
  const scrollRef = useRef(null);

  const scroll = (dir) => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * 280, behavior: "smooth" });
  };

  return (
    <section className="section-shell">
      <div className="section-inner">
        <Reveal>
          <div className="flex items-end justify-between mb-6 gap-4">
            <div>
              <p className="label-cap text-accent mb-2">Curated Selection</p>
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-primary">Featured Products</h2>
            </div>
            <div className="hidden sm:flex gap-2">
              <button
                type="button"
                onClick={() => scroll(-1)}
                className="w-10 h-10 rounded-full border border-border flex items-center justify-center text-primary hover:border-accent hover:bg-surface-alt transition-colors active:scale-[0.97]"
                aria-label="Scroll left"
              >
                <ChevronLeft size={20} />
              </button>
              <button
                type="button"
                onClick={() => scroll(1)}
                className="w-10 h-10 rounded-full border border-border flex items-center justify-center text-primary hover:border-accent hover:bg-surface-alt transition-colors active:scale-[0.97]"
                aria-label="Scroll right"
              >
                <ChevronRight size={20} />
              </button>
            </div>
          </div>
        </Reveal>

        <div
          ref={scrollRef}
          className="flex gap-5 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide"
          style={{ scrollSnapType: "x mandatory" }}
        >
          {PRODUCTS.map((p, i) => (
            <article
              key={p.name}
              className="flex-shrink-0 w-[220px] sm:w-[240px] snap-start bg-surface border border-border rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-2 hover:shadow-xl"
            >
              <div className="aspect-square overflow-hidden">
                <img src={p.image} alt={p.name} loading="lazy" className="w-full h-full object-cover" />
              </div>
              <div className="p-4">
                <span className="text-[10px] font-semibold uppercase tracking-wider text-accent">{p.category}</span>
                <h3 className="font-serif font-bold text-primary mt-1">{p.name}</h3>
                <a
                  href="#inquiry"
                  className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-primary group/link active:scale-[0.97]"
                >
                  Inquire <ArrowRight size={14} className="transition-transform group-hover/link:translate-x-1" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
